import {
	Collection,
	Country,
	Currency,
	Department,
	DocumentCostType,
	Employee,
	Item,
	Location,
	PaymentMethod,
	PaymentTerm,
	Salesperson,
	State,
	Warehouse
} from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'
export class CommonService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}

	async getSalespersons(): Promise<Collection<Salesperson>> {
		return this.getData<Salesperson[]>(`${APIEndpoints.common}/salespersons`).then((res) => {
			return new Collection(Salesperson, res)
		})
	}

	async getCountries(): Promise<Collection<Country>> {
		return this.getData<Country[]>(`${APIEndpoints.common}/countries`).then((res) => {
			return new Collection(Country, res)
		})
	}
	async getStates(country: string): Promise<Collection<State>> {
		return this.getData<State[]>(`${APIEndpoints.common}/states/${country}`).then((res) => {
			return new Collection(State, res)
		})
	}
	async getAllStates(): Promise<Collection<State>> {
		return this.getData<State[]>(`${APIEndpoints.common}/states/`).then((res) => {
			return new Collection(State, res)
		})
	}
	async getCurrencies(): Promise<Collection<Currency>> {
		return this.getData<Currency[]>(`${APIEndpoints.common}/currencies`).then((res) => {
			return new Collection(Currency, res)
		})
	}

	async getPaymentMethods(): Promise<Collection<PaymentMethod>> {
		return this.getData<PaymentMethod[]>(`${APIEndpoints.common}/paymethods`).then((res) => {
			return new Collection(PaymentMethod, res)
		})
	}

	async getPaymentTerms(): Promise<Collection<PaymentTerm>> {
		return this.getData<PaymentTerm[]>(`${APIEndpoints.common}/payterms`).then((res) => {
			return new Collection(PaymentTerm, res)
		})
	}

	async getLocations(): Promise<Collection<Location>> {
		return this.getData<Location[]>(`${APIEndpoints.subJob}/locations`).then((res) => {
			return new Collection(Location, res)
		})
	}

	async getDepartments(): Promise<Collection<Department>> {
		return this.getData<Department[]>(`${APIEndpoints.common}/departments`).then((res) => {
			return new Collection(Department, res)
		})
	}

	async getEmployees(): Promise<Collection<Employee>> {
		return this.getData<Employee[]>(`${APIEndpoints.common}/employees`).then((res) => {
			return new Collection(Employee, res)
		})
	}
	async getEmployee(emailPrefix: string): Promise<Employee> {
		return this.getData<Employee>(`${APIEndpoints.common}/employees/${emailPrefix}`).then((res) => {
			return res
		})
	}

	async getItems(): Promise<Collection<Item>> {
		return this.getData<Item[]>(`${APIEndpoints.common}/items`).then((res) => {
			return new Collection(Item, res)
		})
	}

	async getWarehouses(): Promise<Collection<Warehouse>> {
		return this.getData<Warehouse[]>(`${APIEndpoints.common}/warehouses`).then((res) => {
			return new Collection(Warehouse, res)
		})
	}

	async getDocumentCostTypes(): Promise<Collection<DocumentCostType>> {
		return this.getData<DocumentCostType[]>(`${APIEndpoints.common}/document-cost-types`).then((res) => {
			return new Collection(DocumentCostType, res)
		})
	}
}
